import { useQuery } from 'react-query';
import { customerResponse } from 'src/models/CRM';
import { fetchCustomer } from 'src/services/CRM/customers';

export default function useCustomer(id) {
  return useQuery<customerResponse>('customer', () => fetchCustomer(id), {
    enabled: id !== undefined && id !== 0
  });
}
